<script lang="ts" setup>
const {
  modelValue = false,
  closeButton = true,
  clickToClose = true,
} = defineProps<{
  modelValue?: boolean;
  closeButton?: boolean;
  clickToClose?: boolean;
}>();

const emit = defineEmits(["update:modelValue"]);

const modal = ref();

const updateValue = (value: boolean) => {
  emit("update:modelValue", value);
};

const onClickOutside = () => {
  if (clickToClose) {
    closeModal();
  }
};

const closeModal = () => {
  updateValue(false);
};

const getTeleportTarget = () => {
  let customElem = document.querySelector("wijsneus-widget");
  let shadowRoot = customElem?.shadowRoot;
  modal.value = shadowRoot?.getElementById("modal");
};

onMounted(() => {
  getTeleportTarget();
});
</script>

<template>
  <Teleport v-if="modal" :to="modal">
    <Transition name="fade">
      <div v-if="modelValue" class="backdrop" @click="onClickOutside()"></div>
    </Transition>
    <Transition name="fade-up">
      <div v-if="modelValue" class="modal">
        <div v-if="closeButton" class="heading">
          <div
            v-if="closeButton"
            class="button button--close"
            @click="closeModal"
          >
            Sluiten<BaseIcon name="expand_more" class="button-icon" />
          </div>
        </div>
        <div class="content">
          <slot></slot>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style lang="scss" scoped>
.backdrop {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  max-height: 95%;
  border-radius: var(--main-border-radius) var(--main-border-radius) 0 0;
  background-color: var(--overlay-body-background-color);
  color: var(--overlay-body-text-color);
}

.heading {
  padding: 5px;
  display: flex;
  justify-content: flex-end;
}

.button {
  display: flex;
  align-items: center;
  padding: 10px;
  margin-left: auto;
  font-size: 0.8rem;
  cursor: pointer;

  &:hover {
    color: var(--overlay-button-background-color);
  }
}

.button-icon {
  font-size: 1.4em;
}

.content {
  max-height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  padding: 20px;
  -webkit-overflow-scrolling: touch;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 500ms cubic-bezier(0.16, 1, 0.3, 1);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition: transform 500ms cubic-bezier(0.16, 1, 0.3, 1);
}

.fade-up-enter-from,
.fade-up-leave-to {
  transform: translateY(100%);
}
</style>
